import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NotfoundComponent } from './demo/components/notfound/notfound.component';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { AuthGuard } from './auth/auth.guard'

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppLayoutComponent,canActivate: [AuthGuard],
                children: [
                    { path: '', loadChildren: () => import('./demo/components/dashboards/dashboards.module').then(m => m.DashboardsModule) },
                    { path: 'master',data: { breadcrumb: 'master' }, loadChildren: () => import('./page/master/master.module').then(m => m.MasterModule) },
                    { path: 'manage',data: { breadcrumb: 'manage' }, loadChildren: () => import('./page/manage/manage.module').then(m => m.ManageModule) },
                    { path: 'timer',data: { breadcrumb: 'timer' }, loadChildren: () => import('./page/timer/timer.module').then(m => m.TimerModule) },
                    { path: 'config',data: { breadcrumb: 'config' }, loadChildren: () => import('./page/config/config.module').then(m => m.ConfigModule) },
                    { path: 'report', data: { breadcrumb: 'report' },loadChildren: () => import('./page/report/report.module').then(m => m.ReportModule) },
                    { path: 'pages', data: { breadcrumb: 'pages' },loadChildren: () => import('./demo/components/pages/pages.module').then(m => m.PagesModule) }
                ]
            },
            { path: 'auth', loadChildren: () => import('./page/auth/auth.module').then(m => m.AuthModule) },
            { path: 'web', loadChildren: () => import('./page/web/web.module').then(m => m.WebModule) },
            { path: 'landing', loadChildren: () => import('./demo/components/landing/landing.module').then(m => m.LandingModule) },
            { path: 'notfound', component: NotfoundComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
